"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsMenu = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _TabSection = require("../../atoms/TabSection");

var _react = require("react");

var _Modal = require("../../organisms/Modal");

var _ButtonV = require("../../atoms/ButtonV2");

var _jsxRuntime = require("react/jsx-runtime");

var TabsMenu = function TabsMenu(_ref) {
  var _ref$tabsSections = _ref.tabsSections,
      tabsSections = _ref$tabsSections === void 0 ? {} : _ref$tabsSections,
      setImagesSection = _ref.setImagesSection,
      setActiveTab = _ref.setActiveTab,
      activeTab = _ref.activeTab,
      updatedDescriptions = _ref.updatedDescriptions,
      updatedDatasheets = _ref.updatedDatasheets,
      images = _ref.images,
      setUpdatedDescriptions = _ref.setUpdatedDescriptions,
      setUpdatedDatasheets = _ref.setUpdatedDatasheets,
      setImages = _ref.setImages;

  var _useState = (0, _react.useState)(tabsSections),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      sections = _useState2[0],
      setSections = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      modal = _useState4[0],
      setModal = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      cancelAccept = _useState6[0],
      setCancelAccept = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      llave = _useState8[0],
      setLlave = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      objeto = _useState10[0],
      setObjeto = _useState10[1];

  var activeSection = function activeSection(key) {
    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var tempArray = {};
    setImagesSection(key === "Imágenes");
    Object.keys(array).forEach(function (section) {
      tempArray[section] = section === key;
      if (section === key) return setActiveTab(key);
    });
    setSections(tempArray);
  };

  (0, _react.useEffect)(function () {
    if (cancelAccept === "Aceptar" && llave !== "") {
      setCancelAccept("");
      setModal(false);
      activeSection(llave, objeto);
      setUpdatedDescriptions([]);
      setUpdatedDatasheets([]);
      setImages({});
    } else if (cancelAccept === "Cancelar" && llave !== "") {
      setModal(false);
      setCancelAccept("");
    }
  }, [cancelAccept]);

  var detectClickFunction = function detectClickFunction(e, key, sections) {
    var _images$values, _images$values$filter;

    var targetIsTheCurrentTab = e.target.innerHTML === activeTab;
    var descriptionsWereUpdated = updatedDescriptions.length > 0;
    var datasheetWereUpdated = updatedDatasheets.length > 0;
    var imagesWereUpdated = (images === null || images === void 0 ? void 0 : (_images$values = images.values) === null || _images$values === void 0 ? void 0 : (_images$values$filter = _images$values.filter(function (f) {
      return !f.id;
    })) === null || _images$values$filter === void 0 ? void 0 : _images$values$filter.length) > 0;
    var dataWereUpdated = descriptionsWereUpdated || datasheetWereUpdated || imagesWereUpdated;

    if (!targetIsTheCurrentTab && !dataWereUpdated) {
      setLlave(key);
      setObjeto(sections);
      activeSection(key, sections);
    } else if (!targetIsTheCurrentTab && dataWereUpdated) {
      setModal(true);
      setLlave(key);
      setObjeto(sections);
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [activeTab && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      show: modal,
      title: "Cambios sin Guardar",
      message: "Est\xE1s cambiando de vista y aun no guardas cambios \xBFEst\xE1s seguro?",
      buttons: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "white",
        label: "Cancelar",
        size: 12,
        onClick: function onClick() {
          return setCancelAccept("Cancelar");
        }
      }, "btn-Cancelar"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        type: "pink",
        label: "Aceptar",
        size: 12,
        onClick: function onClick() {
          return setCancelAccept("Aceptar");
        }
      }, "btn-Aceptar")]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      children: Object.keys(sections).map(function (key, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TabSection.TabSection, {
          label: key,
          active: sections[key],
          onClick: function onClick(e) {
            detectClickFunction(e, key, sections);
          }
        }, index);
      })
    })]
  });
};

exports.TabsMenu = TabsMenu;